<template>
  <div class="mask"
       v-if="isServeDialog">
    <div class="serve-dialog">
      <img class="serve-dialog-close"
           :src="imgUrl + 'closec.png'"
           @click="isServeDialog = false" />
      <div class="dialog-title">客服热线</div>
      <div class="serve-phone-number">{{ cellphone ||"400-163-3686"}}</div>
      <img class="bottom-pic"
           :src="imgUrl + 'tk.png'" />
      <div class="bottom-text">联系我们，咨询更多问题</div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["cellphone"],
  data() {
    return {
      imgUrl: 'https://sc2.hexiaoxiang.com/h5/purchase/img/',
      isServeDialog: false
    }
  },
  methods: {
    show() {
      this.isServeDialog = true
    }
  }
}
</script>
<style lang="scss" scoped>
.mask {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.6);
  z-index: 200;
}
.serve-dialog {
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 7px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 247px;
  height: 289px;
  background: white;
  overflow: hidden;
  .serve-dialog-close {
    position: absolute;
    top: 5px;
    right: 9px;
    width: 23px;
    height: 23px;
  }
  .dialog-title {
    margin: 38px 0;
    font-size: 18px;
  }
  .serve-phone-number {
    font-size: 22px;
    color: rgba(3, 169, 244, 1);
  }
  .bottom-text {
    position: absolute;
    left: 50%;
    bottom: 32px;
    transform: translateX(-50%);
    width: 100%;
    font-size: 15px;
    font-family: PingFangSC-Medium;
    font-weight: 500;
    color: rgba(255, 255, 255, 1);
    text-align: center;
  }
  .bottom-pic {
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 260px;
  }
}
</style>